module.exports = __webpack_public_path__ + "img/NA.1c88ec44.svg";